import { useState } from "react"
import { useGetShowsQuery } from "../../features/CallApi"
import { useEffect } from "react"
import { Button, ButtonGroup, Card, Col, FloatingLabel, Form, Image, Modal, Row } from "react-bootstrap"
import { LoadScreenMin } from "../UI/LoadScreenMin"
import { useTranslation } from "react-i18next"
import { Link, NavLink, useNavigate, useSearchParams } from "react-router-dom"
import { format } from "date-fns"
import { ru, enUS } from 'date-fns/locale';
import { useDispatch, useSelector } from "react-redux"
import { useTokenTP } from "../../features/useTokenTP"
import { usePostWaitListMutation, usePutPersonMutation } from "../../features/CallTPApi"
import { useForm } from "react-hook-form"
import { setAlertMsgStore } from "../../features/alertMsgSlisce"
import { InputPhone } from "../PayTickets/InputPhone"
import { ShowSchedulesItem } from "../UI/ShowSchedulesItem"
import { BuyButton, DateBtn, InfoLine } from "../Afisha/AfishaSlider"


const BUTTON_TYPES = {
    SCHEDULE: 0,  // Изменено на строки
    LINK: 1,      // потому что select возвращает строку
    WAITING_LIST: 2
};

const WaitListForm = ({ item }) => {
    const [t] = useTranslation("global");
    const [show, setShow] = useState(false)
    const whoami = useSelector((state) => state.whoamiTP)
    const [disabledForm, setDisabledForm] = useState(false)
    const { logOutTP } = useTokenTP()
    const [putPerson, { isLoading: isPutPerson }] = usePutPersonMutation()
    const dispatch = useDispatch()
    const [postWaitLists, { isLoading }] = usePostWaitListMutation()

    const { register, handleSubmit, formState: { errors }, reset, setValue, setError } = useForm({ mode: 'onChange' });
    const submitForm = async (data) => {
        const body = {
            ...data,
            eventId: item.waitListButtonEventId,
            firstName: data.firstName,
            lastName: data.lastName,
            email: data.email,
            phone: data.phone,

        }
        if (disabledForm) {
            console.log("не обновляем данные покупателя")
            createWaitList(body)
        } else {
            console.log("обновляем данные покупателя")
            const personNewData = {
                id: data.id,
                firstName: data.firstName,
                lastName: data.lastName,
                eMail: data.eMail,
                phone: '+' + data.phone.replace(/\D+/g, ""),
            };
            await putPerson(personNewData).then(async (res) => {
                console.log(!res.error)
                if (!res.error) {
                    createWaitList(body)
                }
                else {
                    dispatch(setAlertMsgStore({ title: `Ошибка обновления данных покупателя.`, variant: 'danger' }))
                }
            })
        }
        return
    }

    const createWaitList = async (data) => {
        console.log(data)
        const body = {
            comment: data.comment,
            eventId: item.waitListButtonEventId,
            ticketCount: data.ticketCount,
            clientId: whoami.id,
            createdById: whoami.id,
            modifiedById: whoami.id,
            waitListStatus: 1,
        }
        postWaitLists(body).then((res) => {
            if (!res.error) {
                dispatch(setAlertMsgStore({ title: `Заявка успешно отправлена!`, variant: 'success' }))
                reset()
                setShow(false)
            }
            if (res.error) {
                dispatch(setAlertMsgStore({ title: `Ошибка создания заявки.`, variant: 'danger' }))
            }
        })
    }

    const agreementLable = () => {
        return (
            <label className="form-check-label" style={{ fontSize: '12px' }}><a href='https://leningradcenter.ru/api/redirecturls/privacy-policy' target={"_blank"} >{t("form.agreement")}</a></label>
        )
    }
    const praviloLable = () => {
        return (
            <label className="form-check-label" style={{ fontSize: '12px' }}><a href='https://leningradcenter.ru/api/redirecturls/public-offer-certificates' target={"_blank"} >{t("form.giftRules")}</a></label>
        )
    }

    useEffect(() => {
        if (whoami) {
            console.log(disabledForm)
            setValue('id', whoami.id)
            setValue('phone', whoami.phone)
            setValue('firstName', whoami.firstName)
            setValue('lastName', whoami.lastName)
            setValue('eMail', whoami.eMail)
            // setNewStatus()

            if (whoami.firstName && whoami.lastName && whoami.eMail) {
                setDisabledForm(true)
                console.log(true)
            }
        }
    }, [whoami])

    return (
        <>
            <Button className='border shadow btn-afisha' style={{
                borderColor: "#272929"
            }} onClick={() => {
                setShow(true)
            }} variant='light'>{item.waitListButtonEventText}</Button>
            <Modal show={show} onHide={() => setShow(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Регистрация в листе ожидания</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {!whoami?.id ?
                        <div>
                            <div className='pe-lg-5 ps-lg-5'>
                                <InputPhone />
                            </div>
                        </div>
                        :
                        <Form onSubmit={handleSubmit(submitForm)} className=''>
                            <div className='d-grid gap-1'>
                                <div className='fs-5 fw-bold'>
                                    {item.name}
                                </div>
                                <FloatingLabel label="Количество билетов">
                                    <Form.Control
                                        type="number"
                                        min={0} // Запрещает ввод значений меньше 0
                                        step={1} // Только целые числа
                                        isInvalid={!!errors.ticketCount}
                                        {...register("ticketCount", {
                                            required: { value: true, message: "Введите количество билетов" },
                                            valueAsNumber: true, // Преобразует строку в число (возвращает number)
                                            setValueAs: (value) => Number(value) || 0, // Преобразование при установке
                                            min: {
                                                value: 0,
                                                message: "Количество билетов не может быть меньше 0"
                                            }
                                        })}
                                        placeholder="0"
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.ticketCount?.message?.toString()}
                                    </Form.Control.Feedback>
                                </FloatingLabel>
                                <FloatingLabel label="Комментарий">
                                    <Form.Control
                                        as="textarea"
                                        placeholder="Введите комментарий"
                                        style={{ height: '100px' }}
                                        {...register('comment', {
                                            required: 'Опишите ваш запрос. Например, укажите желаемые места в зале, дату или другие важные детали',
                                        })}
                                        isInvalid={!!errors.comment}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.comment?.message?.toString()}
                                    </Form.Control.Feedback>
                                </FloatingLabel>
                                <FloatingLabel label="Телефон">
                                    <Form.Control placeholder="Телефон" disabled={true} {...register('phone')} />
                                </FloatingLabel>
                                <div className='d-flex gap-1'>
                                    <FloatingLabel label="Имя" className='flex-fill'>
                                        <Form.Control placeholder="Имя" isInvalid={errors?.firstName ? true : false} disabled={disabledForm} {...register('firstName', { required: true })} />
                                    </FloatingLabel>
                                    <FloatingLabel label="Фамилия" className='flex-fill'>
                                        <Form.Control placeholder="Фамилия" isInvalid={errors?.lastName ? true : false} disabled={disabledForm}  {...register('lastName', { required: true })} />
                                    </FloatingLabel>
                                </div>
                                <FloatingLabel label="E-mail">
                                    <Form.Control placeholder="E-mail" isInvalid={errors?.eMail ? true : false} disabled={disabledForm}  {...register('eMail', {
                                        required: true, pattern: {
                                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                            message: "invalid email address"
                                        }
                                    })} />
                                </FloatingLabel>
                                {disabledForm &&
                                    <Button variant="light" onClick={() => { setDisabledForm(false) }} size="sm">Изменить данные</Button>
                                }
                                <Button className='mb-2' variant="link" size='sm' onClick={() => { logOutTP() }}>Выйти из профиля</Button>
                                <div>
                                    <div className="d-flex mb-2">
                                        <Form.Switch label={agreementLable()}
                                            className="check-input-lc"
                                            isInvalid={errors.policy?.message !== undefined}
                                            {...register("policy",
                                                { required: { value: true, message: "Необходимо согласие на обработку персональных данных" } }
                                            )} />
                                    </div>
                                    {/* <div className="d-flex">
                                        <div className=" form-check form-switch">
                                            <label className="form-check-label " style={{ fontSize: "12px" }}>{t("form.receiveNewsletter")}</label>
                                            <input type="checkbox" className="form-check-input check-input-lc" {...register("receiveNewsletter", {})} />
                                        </div>
                                    </div> */}
                                </div>
                                <div className='d-flex'>
                                    <input type={'submit'} value={t("form.confirm")} className='btn btn-lc btn-lc-cert w-auto flex-fill' />
                                </div>
                            </div>
                        </Form>
                    }
                </Modal.Body>
            </Modal>
        </>
    )
}

export const ButtonAfisha = ({ item, setShowModel, setDateList, setParam, searchParams }) => {
    const [t] = useTranslation('global')
    useEffect(() => {
        if (searchParams.get("selectShow") === item.seoUrl) {
            setDateList(item.showSchedules)
        }
        else {
            // hideModal()
        }
    }, [searchParams])
    return (
        <div className='d-grid gap-1' size='sm'>
            {/* {item.buttonType} */}
            {(item.showSchedules?.length > 0 && item.buttonType === BUTTON_TYPES.SCHEDULE) &&
                <Button className='border shadow btn-afisha' style={{ borderColor: "#272929" }} onClick={() => {
                    setShowModel(true)
                    setDateList(item.showSchedules)
                    setParam(item.seoUrl)
                }} variant='light'>{t("afisha.buytickets")}</Button>
                // :
                // <Button className='border shadow btn-afisha' variant='light'>{t("afisha.subscribe")}</Button>
            }
            {item.buttonType === BUTTON_TYPES.LINK &&
                <Button className='border shadow btn-afisha' style={{
                    borderColor: "#272929"
                }} onClick={() => {
                    window.open(item.buyButtonLink, '_blank').focus();
                }} variant='light'>{item.buyButtonText}</Button>
            }
            {item.buttonType === BUTTON_TYPES.WAITING_LIST &&
                <WaitListForm item={item} />
            }
            {/* <Button><BoxArrowInRight size={18} /></Button> */}
        </div>
    )
}

export const Shows = ({ selLanguage }) => {

    const [t] = useTranslation("global");
    const [pageIndex, setPageIndex] = useState(1)
    const [pageSize, setPageSize] = useState(30)
    const [selLng, setSelLng] = useState('')
    const [showModel, setShowModel] = useState(false)
    const [dateList, setDateList] = useState()
    const navigate = useNavigate()
    let [searchParams, SetSearchParams] = useSearchParams();

    const toNav = (link) => {
        window.scrollTo(0, 0)
        navigate(link)
    }

    useEffect(() => {
        if (selLanguage) {
            setSelLng(selLanguage)
        }
    }, [selLanguage])

    const { data, isLoading } = useGetShowsQuery({ pageIndex, pageSize, selLng })
    const setParam = (seoUrl) => {
        console.log(seoUrl)
        searchParams.set("showModal", 'true')
        searchParams.append("selectShow", seoUrl)
        SetSearchParams(searchParams)
    }

    const hideModal = () => {
        setShowModel(false)
        searchParams.delete("selectShow")
        searchParams.delete("showModal")
        SetSearchParams(searchParams)
        setDateList(null)

    }

    useEffect(() => {
        console.log(dateList)
    }, [dateList])

    return (
        <>
            <Modal
                show={showModel}
                size="md"
                fullscreen={"sm-down"}
                aria-labelledby="contained-modal-title-vcenter"
                centered
                onHide={() => hideModal()}
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        {t("afisha.selectdate")}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {dateList &&
                        <>
                            {dateList.map(item =>
                                <ShowSchedulesItem key={item.id} item={item} />
                            )}
                        </>
                    }
                </Modal.Body>
            </Modal>
            {!isLoading ?
                <>
                    {data.getShows.length > 0 &&
                        <>
                            {data.getShows.map(item =>
                                <Row key={item.id} className='mb-3 justify-content-center' >
                                    <Col xs={5} lg={4}>
                                        <Image style={{ cursor: 'pointer' }} onClick={() => { toNav(`/about-project/show/${item.seoUrl}`) }} fluid src={`/api/shows/afisha-img/${item.id}`} alt={item.name} />
                                    </Col>
                                    <Col xs={7} lg={6} className="pt-3">
                                        <Link to={`/about-project/show/${item.seoUrl}`} className='link-decor'>
                                            <h3 className='afisha-event-title mt-3 mb-0'>
                                                <strong>{item.name}</strong>
                                            </h3>
                                            <p>
                                                <strong>
                                                    {item.shortDescription}
                                                </strong>
                                            </p>
                                            <InfoLine
                                                ageCategory={item.ageCategory}
                                                duration={item.showSchedules?.[0]?.duration}
                                                stage={item.stage}
                                            />
                                        </Link>
                                        <div>
                                            {item.buttonType === 0 && item.showSchedules?.length > 0 && (
                                                <div>
                                                    {/* <p className="afisha-date-label">Выберите дату</p> */}
                                                    <div className="d-flex flex-wrap gap-1 mb-2">
                                                        {item.showSchedules.slice(0, 5).map((date) => (
                                                            <DateBtn key={date.id} schedule={date} />
                                                        ))}
                                                        {item.showSchedules.length > 5 && (
                                                            <span className="afisha-more-dates">+{item.showSchedules.length - 5}</span>
                                                        )}
                                                    </div>
                                                </div>
                                            )}

                                            <div className="d-flex align-items-center justify-content-between flex-fill">
                                                <BuyButton item={item} />
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            )}
                        </>
                    }
                </>
                :
                <LoadScreenMin />
            }
        </>
    )
}